import { z } from 'zod'

export const CustomMatchSchema = z.object({
	path: z.string(),
	condition: z.enum([
		'equals',
		'not equals',
		'starts with',
		'ends with',
		'contains',
	]),
	value: z.string(),
})

export type CustomMatch = z.infer<typeof CustomMatchSchema>
